import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../../../redux/actions';
import { BORROW_PROJECT, REPAY_PROJECT } from '../constants/loanProjects';

// ยอดคงเหลือ (ตามจริง) ของคู่ยืม-คืนหลัก — สูตรเดียวกับ currentBalance ใน LoanPairSummaryCard
// (ยอดตั้งต้น + ยืม − คืน เฉพาะรายการตั้งแต่วันกำหนดยอดคงเหลือ) แต่คำนวณเองเพราะแท็บ
// "เจ้าหนี้ / ลูกหนี้" ไม่ได้เมานต์การ์ดนั้น (ดึงแค่ยอดรวม size=1 ไม่โหลดรายการ)
// refreshKey เปลี่ยน (เช่นสลับแท็บ) → ดึงใหม่ | null = ไม่มีคู่ / ระหว่างโหลด / โหลดไม่สำเร็จ
export function useLoanActualBalance(pair, refreshKey) {
  const dispatch = useDispatch();
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    if (!pair?.customer_id || !pair?.customer_id_repay) {
      setBalance(null);
      return undefined;
    }

    let cancelled = false;
    const sinceCutoff = (customerId, project) => dispatch(actions.listPaymentsByCustomer({
      customerId,
      page: 1,
      size: 1,
      projectName: project.name,
      projectNumber: project.number,
      dateFrom: pair.opening_balance_date || null,
    }));

    Promise.all([
      sinceCutoff(pair.customer_id, BORROW_PROJECT),
      sinceCutoff(pair.customer_id_repay, REPAY_PROJECT),
    ])
      .then(([borrow, repay]) => {
        if (cancelled) return;
        setBalance(
          Number(pair.opening_balance_seed || 0)
            + Number(borrow?.totalAmountSinceCutoff || 0)
            - Number(repay?.totalAmountSinceCutoff || 0),
        );
      })
      .catch(() => {
        if (!cancelled) setBalance(null);
      });

    return () => { cancelled = true; };
  }, [
    pair?.id,
    pair?.customer_id,
    pair?.customer_id_repay,
    pair?.opening_balance_date,
    pair?.opening_balance_seed,
    refreshKey,
  ]);

  return balance;
}

export default useLoanActualBalance;
